import ApiClient from "../ampm-world";
import { ContactPageResource, FeedbackResource } from "../generated-api";

export class ApiContacts {
  static async getContactsPage(lang: string): Promise<ContactPageResource> {
    return ApiClient.get<ContactPageResource>(`/${lang}/page/contact`);
  }

  static async postContactForm(form: FeedbackResource, lang: string) {
    await ApiClient.post(`/${lang}/feedback`, form);
  }
}
